import { useState } from "react";

export default function CSAT({ onSubmit }) {
  const [value, setValue] = useState(null);
  const [note, setNote] = useState("");

  if (value !== null) return <p className="text-xs text-gray-600">Thanks for your feedback!</p>;

  const send = (v) => {
    setValue(v);
    onSubmit?.(v, note);
  };

  return (
    <div className="mt-3 flex items-center gap-2">
      <span className="text-xs text-gray-600">Was this helpful?</span>
      {[1,2,3,4,5].map((n) => (
        <button key={n} onClick={() => send(n)}
          className="text-xs border rounded px-2 py-1 hover:bg-gray-50">{n}</button>
      ))}
      <input
        placeholder="Optional note"
        className="ml-2 border rounded px-2 py-1 text-xs"
        value={note} onChange={(e)=>setNote(e.target.value)}
      />
    </div>
  );
}
